import React, { useState, useEffect } from 'react'
import { Button, Card, Pagination, SubmissionError } from '../../components'
import { ReactComponent as BackButton } from "../../assets/icons/ui/BackButton.svg"
import CustomModal from '../../components/CustomModal'
import InventoryMapContainer from './InventoryMapContainer'
import { services } from '../../services'
import ExportFileModal from '../ExportFileModal'
import ExportFileContent from '../ExportFileModal/ExportFileContent'

const User = require('../../assets/icons/inventoryreference/account.svg')
const ReferenceGroup = require('../../assets/icons/inventory/ReferenceGroup.svg')
const Location = require('../../assets/icons/inventoryreference/location.svg')
const Spinner = require('../../assets/icons/ui/loader.gif')
const MapView = require('../../assets/icons/inventory/MapView.svg')
const TableView = require('../../assets/icons/inventory/ListView.svg')
const Info = require('../../assets/icons/inventory/Info.svg')

const { api, exportFile } = services

const InventoryReport = (props) => {
  const { history } = props
  const [reportDetails, setReportDetails] = useState('')
  const [toggleView, setToggleView] = useState(false)
  const [acctDetailReport, setAcctDetailReport] = useState('')
  const [loading, setLoading] = useState(true)
  const [inventoryCount, setInventoryCount] = useState(0)
  const [activePage, setActivePage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageData, setPageData] = useState('')
  const [, setNoCloseIcon] = useState(false)
  const [isErrorModal,setIsErrorModal] = useState(false)
  const [isErrorModalStyle,setIsErrorModalStyle] = useState(false)
  const [closeIconStatus, setCloseIconStatus] = useState(true)
  const [refFlag] = useState(window.location.href.indexOf("InventoryReferenceInfo") === -1)
  const [isExportModal, setIsExportModal] = useState(false)
  const [isExportLoading, setIsExportLoading] = useState(false)
  const IS_OK = status => status === 200
  
  const PER_PAGE = 25
  var TOTAL_COUNT = reportDetails.length
  var lastIndex = activePage * PER_PAGE
  var firstIndex = lastIndex - PER_PAGE
  const { onMount, location } = props

  useEffect(() => {
    onMount(true)
    if(refFlag){
      api.getInventoryReport(location.state.ReferenceInfo[0].BillAccountNumber)
        .then((response) => {
          window.scrollTo(0,0)
          setReportDetails(response.data.inventoryLineItems)
          setInventoryCount(response.data.totalInventoryItemCount)
          setAcctDetailReport(location.state.ReferenceInfo)
          setPageData(response.data.inventoryLineItems.slice(firstIndex, lastIndex))
          setLoading(false)
        })
    }else{
      api.getInventoryReport(location.state.ReferenceInfo[0].Reference_Acct)
        .then((response) => {
          window.scrollTo(0,0)
          setReportDetails(response.data.inventoryLineItems)
          setInventoryCount(response.data.totalInventoryItemCount)
          setAcctDetailReport(location.state.ReferenceInfo)
          setPageData(response.data.inventoryLineItems.slice(firstIndex, lastIndex))
          setLoading(false)
        })
    }

    return () => {
      onMount(false)
    }
  }, [onMount, firstIndex, lastIndex, location, refFlag])

  const backFunction = () => {
    if (refFlag) {
      history.push({
        pathname: '/InventoryAccount/',
        state: { AccountList: props.location.state.AccountList },
      })
    } else {
      history.push({
        pathname: '/InventoryAccount/InventoryReferenceInfo',
        state: { AccountList: props.location.state.AccountList },
      })
    }
  }

  const changeCurrentPage = (pageNumber) => {
    setCurrentPage(pageNumber)
    setActivePage(pageNumber)
    lastIndex = pageNumber * PER_PAGE
    firstIndex = lastIndex - PER_PAGE
    setPageData(reportDetails.slice(firstIndex, lastIndex))
  }
  
  const handleExport = () =>{
    let refNum = []
    if(refFlag){
      refNum = props.location.state.ReferenceInfo[0].BillAccountNumber
    }
    else{
      refNum =  props.location.state.ReferenceInfo[0].Reference_Acct
    }
    setIsExportModal(true)
    setIsExportLoading(true)
    api.downloadedFile([refNum])
      .then((response) =>{
        if (IS_OK(response.status)) {
          exportFile.saveData(response.data)
          setIsExportLoading(false)
          setIsExportModal(false)
        }
      }, (error) => {
        setIsExportModal(false)
        setIsExportLoading(false)
        setNoCloseIcon(true)
        setIsErrorModalStyle(true)
        setIsErrorModal(true)
      })
  }

  //modal toggle
  const modalToggle = () => {
    setNoCloseIcon(false)
    setIsErrorModalStyle(false)
    setIsErrorModal(false)
  }
  //hiding close icon modal for confirm modal 
  const noCloseIconOnModal = () => {
    setCloseIconStatus(true)
  }


  const accountDetailCard = () => {
    if (reportDetails) {
      var result = reportDetails.map(a => a.accountName)
    }
    if (acctDetailReport === [] || acctDetailReport === undefined || acctDetailReport === "" || reportDetails === [] || reportDetails === undefined || reportDetails === "") {
      return (
        <Card >
          <div className='noRecord'>No Record Found</div>
        </Card>
      )
    }
    else {
      return <div>
        {acctDetailReport && reportDetails && acctDetailReport.map((data, index) => {
          return (
            <Card key={index} className={!toggleView ? "" : "accountCardmaxwidth"}>
              <div className='reference-Rowinfo'>
                <li className='reference-li'>
                  <span className="account-card-image">
                    <img src={User} alt='user-icon' />
                  </span>
                </li>
                <li className='reference-li reference-acctName-content'>
                  <div>
                    <div className="account-card-content">Account Name</div>
                    <span className="account-card-details">{result[0]}</span>
                  </div>
                </li>
                <div className="vertical-line"></div>
                <li className='reference-li'>
                  <span className="account-card-image">
                    <img src={ReferenceGroup} alt='account-icon' />
                  </span>
                </li>
                <li className='reference-li reference-acct-content'>
                  <div>
                    <div className="account-card-content">Reference Number</div>
                    <span className="account-card-details">{refFlag ? data.BillAccountNumber : data.Reference_Acct}</span>
                  </div>
                </li>
                <div className="vertical-line"></div>
                <li className='reference-li reference-mobile-view'>
                  <span className="account-card-image">
                    <img src={Location} alt='location-icon' />
                  </span>
                </li>
                <li className='reference-li reference-mobile-view'>
                  <div>
                    <div className="account-card-content">Address</div>
                    <span className="account-card-details">{refFlag ? data.ServiceAddressCompressed : data.Address}</span>
                  </div>
                </li>
              </div>
            </Card>
          )
        })}
      </div>
    }
  }
  
  const renderHeader = () => {
    return <Card className='reportHeaderCard'>
      <div className='reportHeader'>
        <span className='reportHeader1'>
          Location ID
        </span>
        <span className='reportHeader2'>
          Pole No
        </span>
        <span className='reportHeader3'>
          Pole Suffix
        </span>
        <span className='reportHeader4'>
          Seq
        </span>
        <span className='reportHeader5'>
          Street Name
        </span>
        <span className='reportHeader6'>
          Component Type
        </span>
        <span className='reportHeader7'>
          Bill Code Title
        </span>
        <span className='reportHeader8'>
          Light
          Status
        </span>
        <span className='reportHeader9'>
          Source
          Type
        </span>
      </div>
    </Card>
  }

  
  const renderBody = () => {
    if (pageData === [] || pageData === undefined || pageData === "" || pageData.length === 0) {
      return (
        <Card >
          <div className='noRecord'>No Record Found</div>
        </Card>
      )
    }
    else {
      return pageData && pageData.map((reportDetails, index) => {
        return (
          <Card key={index} className='reportBodyCard'>
            <div className="reference-body-card">
              <div className='reference-Rowinfo'>
                <li className='reference-li'>
                  <span className='reportBody1' >
                    {reportDetails.locationID}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody2'>
                    {reportDetails.poleNumber}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody3' >
                    {reportDetails.poleSuffix}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody4' >
                    {reportDetails.seqNo}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody5' >
                    {reportDetails.streetName}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody6'>
                    {reportDetails.componentType}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody7' >
                    {reportDetails.billCodeTitle}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody8' >
                    {reportDetails.lightStatus}
                  </span>
                </li>
                <li className='reference-li'>
                  <span className='reportBody9'>
                    {reportDetails.sourceType}
                  </span>
                </li>
              </div>
            </div>
          </Card>
        )
      })
    }
  }

  const toggleMapTableView = () => {
    setToggleView(!toggleView)
  }
  //pagination rendering function
  const paginationDiv = () => {
    return (
      <div className="pagination">
        <span className="pagination-details">
          {pageData.length === 0 ? 'Showing 0 - 0 of 0 component' : <span>Showing {firstIndex === 0 ? 1 : firstIndex} - {TOTAL_COUNT <= lastIndex ? TOTAL_COUNT : lastIndex} of {TOTAL_COUNT} {lastIndex === 1 ? "component" : "components"}</span>}
        </span>
        {reportDetails.length > 25 ?
          <Pagination currentPage={currentPage} activePage={activePage} totalSize={TOTAL_COUNT} sizePerPage={PER_PAGE} changeCurrentPage={changeCurrentPage} firstPageText="First"  lastPageText="Last" showFirstLastPages={true} nextPageText="Next" previousPageText="Prev" /> : null}
      </div>
    )
  }

  return (
    <>
      <div className={!toggleView ?"report-container":"report-switchcontainer"} data-test="ReportComponent">
        <h1 className={!toggleView ?"report-outage__title":"report-outage__title-maxwidth"} data-test='ReportContent'>Inventory Report</h1>
        {loading ?
          <div className="loading-spinner">
            <img src={Spinner} className ="spinner-alignment" alt="Icon"/>
            <span className="loading-message">Loading .....</span>
            <span>Please wait while we load your data</span>
          </div>
          :
          <div>
            {accountDetailCard()}
            <section className={!toggleView ?"inventory-report-actions":"inventory-report-actions-maxwidth"}>
              {!toggleView ? <Button
                className={inventoryCount === 0 ? `report-button-disabled`:`-primary reportexport`}
                aria-label={`Report ExportCSV`}
                data-a11y-focus="first"
                onClick={handleExport}
              >
              Export CSV
              </Button>
                :
                ''}
              <Button
                className={inventoryCount === 0 ? `switch-button-disabled`: `-secondary switch-to-map`}
                aria-label={`Switch to Map View`}
                data-a11y-focus="first"
                onClick={toggleMapTableView}
              >
                <span className='masterAccount-AddIcon'>{!toggleView ? <img src={MapView} alt="MapView" /> :
                  <img src={TableView} alt='TableView' />}</span>
                <span className='report-AddText'>{!toggleView ? 'Switch to Map View' : 'Switch to Table View'}</span>
              </Button>
              {isErrorModal && isErrorModalStyle
                ? <CustomModal
                  modalContent={ 
                    <SubmissionError
                      noCloseIcon={noCloseIconOnModal}
                      onclickOpen={modalToggle}
                      setIsErrorModalStyle={setIsErrorModalStyle}
                      tryagainClick={handleExport}
                    /> }
                  onclickOpen={modalToggle}
                  isShowContent={true}
                  hideCloseIcon={closeIconStatus}
                  noCloseIcon={noCloseIconOnModal}
                  isErrorModalStyle={isErrorModalStyle}
                  setIsErrorModalStyle={setIsErrorModalStyle}
                /> : null}
            </section>
            {TOTAL_COUNT >= 500 && toggleView === false ?
              <div className = "inventory-export-warning">
                <div className="inventory-view-warning-icon">
                  <img src={Info}  alt="Icon"/>
                  <span className="mobile-view-content" data-test="mobile-view-content">
                    This online view is limited to 500 components. For a complete inventory listing please
                    use the "Export CSV" button above to export the file</span>
                </div>
              </div> : null}
            {!toggleView ? <div>
              {renderHeader()}
              {renderBody()}
              {paginationDiv()}
            </div>
              :
              <InventoryMapContainer refNumber={props.location.state.ReferenceInfo[0].BillAccountNumber ? props.location.state.ReferenceInfo[0].BillAccountNumber : props.location.state.ReferenceInfo[0].Reference_Acct} />
            }
          </div>}

        <section className={!toggleView ?"inventory-cancel-actions":"inventory-cancel-actions-maxwidth"}>
          <Button
            className={`-secondary reportcancel`}
            aria-label={`Cancel and return to homepage`}
            data-a11y-focus="first"
            onClick={() => history.push('/')}
          >
            Cancel
          </Button>
          <Button
            className={`button -link-button-back -secondary back reportBack`}
            aria-label={`Back`}
            data-a11y-focus="first"
            onClick={backFunction}
          >
            <BackButton/>
          </Button>
        </section>
      </div>
      <ExportFileModal isExportModal={isExportModal}>
        <ExportFileContent 
          isExportLoading={isExportLoading} 
          setIsExportModal={setIsExportModal} 
        />
      </ExportFileModal>
    </>
  )
}

export default InventoryReport